import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  mentorApprovedActivity,
  mentorRejectedActivity
} from 'actions/activity'
import { setUnreadFeedbackCount } from 'actions/myquests'
import { mentorNotificationPusherCallback } from 'utils/activity'

export default (user, orgId, isMentor) => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (user && orgId && !isMentor) {
      let lChannel = window.oeQwPusherInstance.subscribe(
        `quest.users.${user.id}`
      )
      lChannel.bind(
        'activity_approval_updated',
        mentorNotificationPusherCallback,
        {
          dispatch,
          actions: {
            mentorApprovedActivity: mentorApprovedActivity,
            mentorRejectedActivity: mentorRejectedActivity,
            setUnreadFeedbackCount: setUnreadFeedbackCount
          }
        }
      )

      return () => {
        lChannel.unbind('activity_approval_updated')
      }
    }
  }, [user, orgId, isMentor, dispatch])
}
